import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  type DocumentSubType,
  DocumentType,
  type Party,
  Respondent,
} from "@/briefpoint-client";
import { definitionAliasDisplay } from "@/components/DocumentGeneration/DiscoveryRequests/Questions";
import { replaceTokens } from "@/components/DocumentWizard/SpecialInterrogatoriesStep/Selections/utils";
import type { CaseResponse, DefinitionItem } from "@/lib/types";
import { convertPartyPositionToPropoundingParty } from "@/screens/DocumentGeneration/GenerateDiscoveryRequestPage";

export interface DefinitionHighlightPropoundProps {
  term: string;
  highlightKey: string;
  definition: DefinitionItem;
  _case: CaseResponse;
  clientName: string;
  docType: DocumentSubType;
  party: Party;
}

const DefinitionHighlightPropound = ({
  term,
  highlightKey,
  definition,
  _case,
  clientName,
  docType,
  party,
}: DefinitionHighlightPropoundProps) => {
  const handleClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();

    const spanElement = e.currentTarget;
    const range = document.createRange();
    range.selectNodeContents(spanElement);

    const selection = window.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);

      setTimeout(() => {
        const customEvent = new CustomEvent("custom:mouseup", {
          bubbles: true,
          cancelable: true,
          detail: { isCustomEvent: true },
        });

        document.dispatchEvent(customEvent);
      }, 0);
    }
  };

  const definitionContentPropound = (
    def: DefinitionItem,
    _case: CaseResponse,
    client: string,
    docType: DocumentSubType,
    party: Party,
  ) => {
    if (!def.content) {
      return "undefined";
    }
    return (
      <>
        "<b>{def.term}</b>"{definitionAliasDisplay(def.aliases ?? undefined)}{" "}
        {replaceTokens(
          {
            propoundingParty: convertPartyPositionToPropoundingParty(
              _case?.clientPosition,
            ),
            documentType: DocumentType.DiscoveryRequest,
            documentSubType: docType,
            respondent: Respondent.Custom,
            respondentCustom: party.name,
            respondingPartyName: party.name,
            propoundingPartyName: client,
            respondingParty: convertPartyPositionToPropoundingParty(
              party?.position,
            ),
          },
          def.content || "",
          true,
          _case?.representativeType,
          _case.usePetitionerAndRespondent ?? false,
        )}
      </>
    );
  };
  return (
    <OverlayTrigger
      key={highlightKey}
      placement={"top"}
      flip={true}
      overlay={
        <Tooltip className="definition-tooltip" id={`tooltip-${highlightKey}`}>
          {definitionContentPropound(
            definition,
            _case,
            clientName,
            docType,
            party,
          )}
        </Tooltip>
      }
    >
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: TODO: replace with button */}
      <span
        style={{
          cursor: "context-menu",
          textDecoration: "underline",
          backgroundColor:
            definition.content === "" || definition.content === undefined
              ? "#FFF8EA"
              : "transparent",
        }}
        onClick={handleClick}
      >
        {term}
      </span>
    </OverlayTrigger>
  );
};

export default DefinitionHighlightPropound;
